import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Dialog from "../../../../../components/templates/dialog";
import { useState } from "react";

export const BackButton = ({ isApply }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleDialogOpen = () => {
    setIsOpen(true);
  };

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <Dialog
          description="작성된 내용이 사라집니다.<br/>정말 페이지에서 벗어나시겠습니까?"
          leftButtonText="취소"
          rightButtonText="확인"
          leftButtonOnClick={handleDialogClose}
          rightButtonOnClick={() => navigate(-1)}
        />
      )}
      <div
        className="px-3 custom-cursor"
        onClick={isApply ? handleDialogOpen : () => navigate(-1)}
      >
        <ArrowLeft className="text-semantic-secondary-foreground-heavy-default w-16 h-16" />
      </div>
    </>
  );
};
